module.exports = __webpack_public_path__ + "img/cad5-1.bc61c6a8.png";